/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseAgent } from '../models/api-response-agent';
import { ApiResponseListAgent } from '../models/api-response-list-agent';
import { ApiResponsePagedResultAgent } from '../models/api-response-paged-result-agent';
import { createAgent } from '../fn/agent-api/create-agent';
import { CreateAgent$Params } from '../fn/agent-api/create-agent';
import { deleteAgent } from '../fn/agent-api/delete-agent';
import { DeleteAgent$Params } from '../fn/agent-api/delete-agent';
import { getAgentByRef } from '../fn/agent-api/get-agent-by-ref';
import { GetAgentByRef$Params } from '../fn/agent-api/get-agent-by-ref';
import { getFreeAgents } from '../fn/agent-api/get-free-agents';
import { GetFreeAgents$Params } from '../fn/agent-api/get-free-agents';
import { listAgent } from '../fn/agent-api/list-agent';
import { ListAgent$Params } from '../fn/agent-api/list-agent';
import { patchStatusAgent } from '../fn/agent-api/patch-status-agent';
import { PatchStatusAgent$Params } from '../fn/agent-api/patch-status-agent';
import { searchAgent } from '../fn/agent-api/search-agent';
import { SearchAgent$Params } from '../fn/agent-api/search-agent';
import { updateAgent } from '../fn/agent-api/update-agent';
import { UpdateAgent$Params } from '../fn/agent-api/update-agent';

@Injectable({ providedIn: 'root' })
export class AgentApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAgentByRef()` */
  static readonly GetAgentByRefPath = '/v1/api/ui/agent/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAgentByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgentByRef$Response(params: GetAgentByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAgent>> {
    return getAgentByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAgentByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAgentByRef(params: GetAgentByRef$Params, context?: HttpContext): Observable<ApiResponseAgent> {
    return this.getAgentByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAgent>): ApiResponseAgent => r.body)
    );
  }

  /** Path part for operation `updateAgent()` */
  static readonly UpdateAgentPath = '/v1/api/ui/agent/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAgent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAgent$Response(params: UpdateAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAgent>> {
    return updateAgent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAgent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAgent(params: UpdateAgent$Params, context?: HttpContext): Observable<ApiResponseAgent> {
    return this.updateAgent$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAgent>): ApiResponseAgent => r.body)
    );
  }

  /** Path part for operation `deleteAgent()` */
  static readonly DeleteAgentPath = '/v1/api/ui/agent/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAgent()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAgent$Response(params: DeleteAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAgent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAgent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAgent(params: DeleteAgent$Params, context?: HttpContext): Observable<void> {
    return this.deleteAgent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createAgent()` */
  static readonly CreateAgentPath = '/v1/api/ui/agent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAgent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAgent$Response(params: CreateAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAgent>> {
    return createAgent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAgent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAgent(params: CreateAgent$Params, context?: HttpContext): Observable<ApiResponseAgent> {
    return this.createAgent$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAgent>): ApiResponseAgent => r.body)
    );
  }

  /** Path part for operation `searchAgent()` */
  static readonly SearchAgentPath = '/v1/api/ui/agent/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAgent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAgent$Response(params: SearchAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAgent>> {
    return searchAgent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAgent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAgent(params: SearchAgent$Params, context?: HttpContext): Observable<ApiResponsePagedResultAgent> {
    return this.searchAgent$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultAgent>): ApiResponsePagedResultAgent => r.body)
    );
  }

  /** Path part for operation `patchStatusAgent()` */
  static readonly PatchStatusAgentPath = '/v1/api/ui/agent/status/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchStatusAgent()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchStatusAgent$Response(params: PatchStatusAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchStatusAgent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchStatusAgent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchStatusAgent(params: PatchStatusAgent$Params, context?: HttpContext): Observable<void> {
    return this.patchStatusAgent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAgent()` */
  static readonly ListAgentPath = '/v1/api/ui/agent/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAgent()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAgent$Response(params: ListAgent$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAgent>> {
    return listAgent(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAgent$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAgent(params: ListAgent$Params, context?: HttpContext): Observable<ApiResponseListAgent> {
    return this.listAgent$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAgent>): ApiResponseListAgent => r.body)
    );
  }

  /** Path part for operation `getFreeAgents()` */
  static readonly GetFreeAgentsPath = '/v1/api/ui/agent/list/free-agents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFreeAgents()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFreeAgents$Response(params: GetFreeAgents$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAgent>> {
    return getFreeAgents(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFreeAgents$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFreeAgents(params: GetFreeAgents$Params, context?: HttpContext): Observable<ApiResponseListAgent> {
    return this.getFreeAgents$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAgent>): ApiResponseListAgent => r.body)
    );
  }

}
